<template>
  <div class="container-fluid py-4 payment-page">

    <!-- ================= HEADER ================= -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-boutique flex-wrap">

      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-credit-card-plus fs-2 text-success"></i>

        <div>
          <h2 class="fw-bold mb-0">Création moyen de paiement</h2>
          <small class="text-white-50">
            Ajouter un nouveau mode de paiement
          </small>
        </div>
      </div>

      <router-link
        class="btn btn-success btn-lg shadow-sm btn-boutique"
        :to="{ name: 'liste_moyen_paiement' }"
      >
        <i class="bi bi-arrow-left-circle me-1"></i>
        Retour
      </router-link>

    </div>

    <!-- ================= FORM CARD ================= -->
    <div class="card shadow-sm rounded card-boutique p-4">

      <div class="row g-4">

        <!-- NOM -->
        <div class="col-md-6">

          <label class="form-label fw-semibold">Nom</label>

          <input
            type="text"
            v-model="moyen.nom"
            class="form-control form-control-boutique"
            placeholder="Ex: Cash, Wave, Orange Money..."
            :class="{ 'is-invalid': error.nom }"
          />

          <div class="invalid-feedback">
            {{ error.nom }}
          </div>

        </div>

        <!-- STATUS -->
        <div class="col-md-6 d-flex align-items-center">

          <div class="form-check form-switch mt-3">

            <input
              class="form-check-input"
              type="checkbox"
              v-model="moyen.isEnabled"
              id="isEnabled"
            />

            <label class="form-check-label ms-2 fw-semibold" for="isEnabled">
              Activé ?
            </label>

          </div>

        </div>

      </div>

      <!-- ACTIONS -->
      <div class="d-flex justify-content-end gap-3 mt-4">

        <button
          class="btn btn-light border px-4 py-2"
          @click="cancel"
        >
          <i class="bi bi-x-circle me-1"></i>
          Annuler
        </button>

        <button
          class="btn btn-success btn-boutique px-4 py-2"
          :disabled="isLoading"
          @click="saveMoyen"
        >

          <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>

          <i v-else class="bi bi-save me-1"></i>

          Enregistrer

        </button>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api'

export default {

  data() {
    return {

      isLoading: false,

      moyen: {
        nom: '',
        isEnabled: true,
        createdBy: null
      },

      error: {
        nom: ''
      }

    }
  },

  computed: {
    currentUser() {
      return this.$store.getters.user
    }
  },

  methods: {

    validateForm() {
      this.error.nom = this.moyen.nom.trim()
        ? ''
        : 'Le nom est obligatoire'

      return !this.error.nom
    },

    async saveMoyen() {

      if (!this.validateForm() || this.isLoading) return

      this.isLoading = true

      try {

        const payload = {
          ...this.moyen,
          createdBy: this.currentUser?.id ?? null
        }

        await api.createItem('moyen_paiements', payload)

        this.$router.push({ name: 'liste_moyen_paiement' })

      } catch (e) {
        console.error(e)
        alert("Erreur lors de l'enregistrement")
      } finally {
        this.isLoading = false
      }

    },

    cancel() {
      this.$router.push({ name: 'liste_moyen_paiement' })
    }

  }

}
</script>

<style scoped>

/* ================= BOUTIQUE STYLE ================= */

.payment-page {
  background: #f5f7fb;
  min-height: 100vh;
}

/* HEADER */
.header-boutique {
  background: linear-gradient(135deg, #064e3b, #10b981);
  color: white;
  padding: 20px;
  border-radius: 18px;
}

/* CARD */
.card-boutique {
  border: none;
  border-radius: 18px;
}

/* INPUT */
.form-control-boutique {
  border-radius: 12px;
  border: 1px solid #dbe3ec;
  padding: 10px 14px;
}

.form-control-boutique:focus {
  border-color: #10b981;
  box-shadow: 0 0 6px #10b98133;
}

/* BUTTON */
.btn-boutique {
  border-radius: 12px;
  background: linear-gradient(135deg, #064e3b, #10b981);
  border: none;
  color: white;
}

</style>